import { useModal } from "mui-modal-provider";
import { ShowFnOutput } from "mui-modal-provider/dist/types";
import { useCallback } from "react";
import {
  MailtenanceModal,
  MaintenanceModalProps,
} from "../components/MaintenanceModal";

export const useMaintenanceModal = () => {
  const { showModal, ...rest } = useModal();

  const showMaintenanceModal = useCallback(
    (props?: MaintenanceModalProps) => {
      const modal: ShowFnOutput<MaintenanceModalProps> = showModal(
        MailtenanceModal,
        {
          onDismiss: () => modal.destroy(),
          ...props,
        }
      );
      return modal;
    },
    [showModal]
  );

  return {
    showModal: showMaintenanceModal,
    ...rest,
  };
};
